import L from 'leaflet'
import { formatLatlng } from './geoUtil'
export var map
export var layerGroup
const STR_MAP_CENTER = 'mapCenter', STR_MAP_ZOOM = 'mapZoom'

export var baseLayerConfig = {
    baseLayer: null,
    chosenSourceId: 0,
    overlayList: [
        {
            name: '天地图中文标注',
            url: 'https://t1.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=be2aa91c7840082553f3039a8016b5b5',
            system: true,
            attribution: '&copy; <a href="https://www.tianditu.gov.cn/">天地图</a> 甲测资字1100471 GS(2023)336号'
        }
    ],
    baseLayerList: [],
    getBaseLayerSource() {
        if (this.baseLayerList.length == 0) {
            return null
        } else
            return this.baseLayerList[this.chosenSourceId]
    },
    getBaseLayer() {
        let base = this.baseLayerList[this.chosenSourceId]
        this.baseLayer = L.tileLayer(base.url, {
            zIndex: 1,
            attribution: base.attribution || ''
        })
        return this.baseLayer
    },
    setMapSource(id) {
        if (id >= this.baseLayerList.length) {
            return
        }
        this.chosenSourceId = id
        if (this.baseLayer) {
            map.removeLayer(this.baseLayer)
        }
        this.getBaseLayer().addTo(map)
    }
}

//初始地图控件
export function initMap(dom) {
    map = L.map(dom, {
        //删除默认的放大缩小
        zoomControl: false,
        attributionControl: false
    }).setView([39.9158, 116.3958], 13); // 设置地图中心点的经纬度和缩放级别

    map.addControl(L.control.attribution({prefix:false}))
    readMapState()
    // 创建并添加缩放控件
    L.control.zoom({
        position: 'bottomleft' // 设置位置在左下角
    }).addTo(map);
    layerGroup = L.layerGroup([], { name: 'default-layer-group', sys: false }).addTo(map)
}
//初始图层
export function initOverlay() {
    baseLayerConfig.getBaseLayer().addTo(map);
    let zIndex = 1
    baseLayerConfig.overlayList.forEach(s => {
        zIndex++
        L.tileLayer(s.url, {
            zIndex,
            attribution: s.attribution || ''
        }).addTo(map);
    })
}

function saveMapState() {
    let center = map.getCenter();
    let zoom = map.getZoom();
    // 将中心点坐标和缩放级别保存到浏览器的本地存储中
    localStorage.setItem(STR_MAP_CENTER, JSON.stringify(center));
    localStorage.setItem(STR_MAP_ZOOM, zoom);
}

function readMapState() {
    // 检查本地存储中是否存在之前保存的中心点坐标和缩放级别
    let savedCenter = JSON.parse(localStorage.getItem(STR_MAP_CENTER));
    let savedZoom = localStorage.getItem(STR_MAP_ZOOM);
    // 如果存在，则将地图视图设置为之前保存的值
    if (savedCenter && savedZoom) {
        map.setView(savedCenter, savedZoom);
    }
}



/**
 * 删除所有的标绘元素
 */
export function removeAllPlot() {
    layerGroup.eachLayer(l => {
        layerGroup.removeLayer(l)
    })

}



// WEBPACK FOOTER //
// ./src/util/mapManager.js